require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-rollup-plugin-bucklescript.json") })
        }
      }, "path---package-rollup-plugin-bucklescript");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-rollup-plugin-bucklescript!./.cache/json/package-rollup-plugin-bucklescript.json
// module id = 922
// module chunks = 231608221292675